import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map, of, switchMap, take, tap } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { UserService } from '../services/user.service';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth0 = inject(AuthService);

  return auth0.isAuthenticated$.pipe(
    take(1),
    tap(authenticated => {
      if (!authenticated) {
        router.navigate(['/']);
      }
    }),
    map(authenticated => authenticated)
  );
};

export const noAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth0 = inject(AuthService);
  const user = inject(UserService);

  return auth0.isAuthenticated$.pipe(
    take(1),
    switchMap(authenticated => {
      // If NOT authenticated => allow the landing page
      if (!authenticated) {
        return of(true);
      }

      // If authenticated => we must check if user is admin or not
      // and redirect him accordingly
      return user.isAdmin$.pipe(
        take(1),
        map(isAdmin => {
          if (isAdmin) {
            router.navigate(['/admin']);
          } else {
            router.navigate(['/projects']);
          }

          // We return false to block the landing route
          return false;
        })
      );
    })
  );
};
